// extracted by mini-css-extract-plugin
module.exports = {"songName":"SongName_songName__inYex","nameText":"SongName_nameText__qwwtl"};